import $ from 'jquery';
import config from '../config/index.js';

/**
 * Module to clear the form when field when clicked on search page
 */
class SearchClearForm {
    /**
     * constructor() scopes these methods so we can efficiently
     * attach / remove events, and cache jquery selectors.
     */
    constructor() {
        this.$clearBtn = $('.js-search-input-clear');
        this.$searchPageInput = $('.js-search-input');
        this.$searchForm = $('.search-form');
        this.scopedClickListener = this.clickListener.bind(this);
        this.env = config.get('env');
        this.processed = false;
    }

    /**
     * clickListener() attaches the events to button
     * @returns {object} returns itself to support chaining
     */
    clickListener() {
        this.$searchPageInput.val('');
        return this;
    }

    /**
     * focusOutListener() attaches the events to input
     * @returns {object} returns itself to support chaining
     * TODO: add this on submit:
     * @see http://stackoverflow.com/questions/4086587/track-event-in-google-analytics-upon-clicking-form-submit
     */
    trackEvent() {
        // Refactor to use a focus out
        const query = window.location.search.split('=')[1];
        if (query) {
            window.ga(
                'send',
                'event',
                'SEARCH_QUERY',
                query);
        }
        return this;
    }

    /**
     * on() attaches all events for this module to execute
     * @returns {object} returns itself to support chaining
     */
    on() {
        this.trackEvent();
        this.$clearBtn.on('click', this.scopedClickListener);
        return this;
    }

    /**
     * off() removes all of the attached events for this module
     * and cleans up the added css. Later on we most likely will create
     * classes for this. TODO: @mbenin create classes for this behavior.
     * @returns {object} returns itself to support chaining
     */
    off() {
        this.$clearBtn.off('click', this.scopedClickListener);
        return this;
    }
}

export default new SearchClearForm();

